
<template>
    <a-select show-search :value="value" placeholder="选择平台类型" allow-clear style="width: 150px"
            :default-active-first-option="false" :filter-option="true" :not-found-content="null" :disabled="isDisabled"
            @change="handleChange">
        <a-select-option v-for="d in data" :key="d.value">
            {{ d.text }}
        </a-select-option>
    </a-select>
</template>
<script>
export default {
    data() {
        return {
            data: [],
        }
    },

    props:{
        value:String,
        isDisabled:Boolean,
        showAll:Boolean
    },

    methods: {
        handleChange(v) {
            this.$emit("input", v);
        },
        doSearch() {
            let that = this;
            let c_params = {
                urlparams: false,
            }

            that.$store.dispatch({
                type: "mcmsmanager/platforms",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    if(that.showAll){
                        that.data = [
                            {
                                value:'',
                                text:'全部',
                                id:'-1'
                            }
                        ];
                    }
                    else{
                        that.data = [];
                    }
                    let result = res.data.data;
                    if(!result){
                        that.message.error("未查询到平台");
                        return;
                    }
                    result.forEach(r => {
                        that.data.push({
                            value: r.platformtype,
                            text: r.platformtypename,
                        });
                    });
                    this.$store.commit({
                        type: 'mcmsmanager/save',
                        payload: {
                            platformtypeList: result
                        }
                    })
                    this.$emit('platformTypeChange', '');
                }
            }).catch(() => {

            });
        },
    },
    mounted(){
        this.doSearch()
    }
   
};
</script>

<style scoped>

</style>
